// tslint:disable
export enum TCSPhoneType {
    /**
     * @description Cell
     */
    Cell = 0,
    /**
     * @description Fax
     */
    Fax = 1,
    /**
     * @description Home
     */
    Home = 2,
    /**
     * @description Work
     */
    Work = 3,
}
(TCSPhoneType as any)['CELL'] = 0;
(TCSPhoneType as any)['FAX'] = 1;
(TCSPhoneType as any)['HOME'] = 2;
(TCSPhoneType as any)['WORK'] = 3;
